"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCountryCodeInAwsRegion = exports.getAwsRegionsByCountryCode = exports.getAwsRegionByCountryCode = exports.isRegionSupportedForBrand = exports.convertCountryStringToIsoCountryCode2Char = void 0;
const types_1 = require("../types");
/**
 * Attempt to convert a string to a 2 character ISO country code
 * @param country Country in an unknown format
 * @returns ISO Country Code. Returns "undefined" if no country could be determined
 */
function convertCountryStringToIsoCountryCode2Char(country) {
    const normalizedCountry = country.toUpperCase().trim();
    // Country is in format "US"
    if (types_1.ISO2_ISO_MAPPING[normalizedCountry]) {
        return normalizedCountry;
    }
    // Country is in format "USA"
    if (types_1.ISO_ISO2_MAPPING[normalizedCountry]) {
        return types_1.ISO_ISO2_MAPPING[normalizedCountry];
    }
    return types_1.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING[normalizedCountry];
}
exports.convertCountryStringToIsoCountryCode2Char = convertCountryStringToIsoCountryCode2Char;
/**
 * Given a brand and region, determine if the region is supported for the brand.
 *
 * @param {Brand} brand
 * The Brand.
 *
 * @param {IsoCountryCode2Char} region
 * A region.
 *
 * @returns {boolean}
 * true - The region is supported for the given brand.
 * false - The region is NOT supported for the given brand.
 */
const isRegionSupportedForBrand = (brand, region) => { var _a, _b; return (_b = (_a = types_1.BRAND_TO_SUPPORTED_REGIONS_MAPPING[brand]) === null || _a === void 0 ? void 0 : _a.includes(region)) !== null && _b !== void 0 ? _b : false; };
exports.isRegionSupportedForBrand = isRegionSupportedForBrand;
/**
 * Given a market region, it returns the AWS region associated
 *
 * @param {IsoCountryCode2Char} region: market region
 *
 * @returns {AwsRegions} The AWS region associated to the market
 */
const getAwsRegionByCountryCode = (region) => {
    var _a;
    const [awsRegion] = (_a = Object.entries(types_1.AWS_REGION_MARKETS).find(([, markets]) => markets.includes(region))) !== null && _a !== void 0 ? _a : [types_1.AwsRegions.USE1];
    return awsRegion;
};
exports.getAwsRegionByCountryCode = getAwsRegionByCountryCode;
/**
 * Given a market region, it returns the AWS regions associated
 *
 * As we migrate, a market can be in two AWS regions at once. It's important to get all the regions
 * so the services can decide which one to use based on their own ENV vars
 * that define the regions the services are running in
 *
 * @param {IsoCountryCode2Char} region: market region
 *
 * @returns {AwsRegions} The AWS region associated to the market
 */
const getAwsRegionsByCountryCode = (region) => {
    var _a;
    const awsRegions = (_a = Object.entries(types_1.AWS_REGION_MARKETS)
        .filter(([, markets]) => markets.includes(region))
        .map(([region]) => region)) !== null && _a !== void 0 ? _a : [types_1.AwsRegions.USE1];
    return awsRegions;
};
exports.getAwsRegionsByCountryCode = getAwsRegionsByCountryCode;
/**
 * Given a AWS region and a RBI market, it returns wether a RBI market runs from this AWS region
 *
 * @param {AwsRegions} awsRegion: region
 * @param {IsoCountryCode2Char} market: market
 *
 * @returns {boolean} Wether the market matches the region given
 */
const isCountryCodeInAwsRegion = (awsRegion, market) => {
    const marketRegionMatch = Object.entries(types_1.AWS_REGION_MARKETS).filter(([region, markets]) => {
        return region === awsRegion && markets.includes(market);
    });
    return marketRegionMatch.length > 0;
};
exports.isCountryCodeInAwsRegion = isCountryCodeInAwsRegion;
//# sourceMappingURL=region.js.map